export default {
  clearFilter({ commit, dispatch }) {
    commit("updateFilterStartDate", "")
    commit("updateFilterEndDate", "")
    commit("updateFilterSeller", null)
    commit("updateFilterCredit", [])
    commit("updateFilterBaseDebt", "")
    commit("updateFilterCoverage", [])
    commit("updateFilterChain", [])
    commit("updateFilterPos", [])
    commit("updateFilterCustomerDocument", "")
    dispatch("resetInitAndEndDate")
    return true
  },
  resetInitAndEndDate({ state, commit }) {
    commit("updateFilterStartDate", state.standard_dates.init_date)
    commit("updateFilterEndDate", state.standard_dates.end_date)
  },
  clearFilterSpecific(
    { commit, dispatch, getters },
    { keyFilter, filterIndex }
  ) {
    if (keyFilter === "end_date" || keyFilter === "init_date") {
      commit("updateFilterStartDate", "")
      commit("updateFilterEndDate", "")
      dispatch("resetInitAndEndDate")
    }

    if (keyFilter === "base_debt") {
      commit("updateFilterBaseDebt", "")
    }

    if (keyFilter === "seller") {
      commit("updateFilterSeller", "")
    }

    if (keyFilter === "credit") {
      const newCreditFilter = getters.credit
      const indexToRemove = newCreditFilter.findIndex(
        filter => filter.value === filterIndex
      )
      if (indexToRemove !== -1) {
        newCreditFilter.splice(indexToRemove, 1)
      }
      commit("updateFilterCredit", newCreditFilter)
    }

    if (keyFilter === "coverage") {
      const newCoverageFilter = getters.coverage
      const indexToRemove = newCoverageFilter.findIndex(
        filter => filter.value === filterIndex
      )
      if (indexToRemove !== -1) {
        newCoverageFilter.splice(indexToRemove, 1)
      }
      commit("updateFilterCoverage", newCoverageFilter)
    }

    if (keyFilter === "chain") {
      const newChainsFilter = getters.chain
      const indexToRemove = newChainsFilter.findIndex(
        filter => filter.uuid === filterIndex
      )
      if (indexToRemove !== -1) {
        newChainsFilter.splice(indexToRemove, 1)
      }
      commit("updateFilterChain", newChainsFilter)
    }

    if (keyFilter === "pos") {
      const newPosFilter = getters.pos
      const indexToRemove = newPosFilter.findIndex(
        filter => filter.uuid === filterIndex
      )
      if (indexToRemove !== -1) {
        newPosFilter.splice(indexToRemove, 1)
      }
      commit("updateFilterPos", newPosFilter)
    }

    if (keyFilter === "customer_document") {
      commit("updateFilterCustomerDocument", "")
    }
  }
}
